"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var components_1 = require("../../components");
var antd_1 = require("antd");
var moment_1 = __importDefault(require("moment"));
var form_item_1 = __importDefault(require("../form-item"));
var ReceiverRequirements_1 = require("../../types/ReceiverRequirements");
var react_intl_1 = require("react-intl");
var ReferenceIdentifiers_1 = __importStar(require("./ReferenceIdentifiers"));
var icons_1 = require("@ant-design/icons");
var RequirementsUtility_1 = require("../../../utils/RequirementsUtility");
var OrderReference_1 = __importDefault(require("./OrderReference"));
var AccountingCost_1 = __importDefault(require("./AccountingCost"));
var react_1 = require("react");
var ProjectReference_1 = __importDefault(require("./ProjectReference"));
var translationMessages = react_intl_1.defineMessages({
    baseInformation_title: {
        id: "baseInformation_title",
        defaultMessage: "Base Information",
    },
    baseInformation_invoiceNo: {
        id: "baseInformation_invoiceNo",
        defaultMessage: "Invoice no.",
    },
    baseInformation_issueDate: {
        id: "baseInformation_issueDate",
        defaultMessage: "Issue date"
    },
    baseInformation_issueDate_title: {
        id: "baseInformation_issueDate_title",
        defaultMessage: "The issue date controls on which settlement period the transfer is registered" // "Útgáfudagsetning stjórnar á hvaða uppgjörstímabili færslan skráist"
    },
    baseInformation_dueDate: {
        id: "baseInformation_dueDate",
        defaultMessage: "Due date"
    },
    baseInformation_dueDate_title: {
        id: "baseInformation_dueDate_title",
        defaultMessage: "Grace date should be the same as due date" // "Eindagi skal vera sá sami og gjalddagi"
    },
    baseInformation_buyerReferenceLabel: {
        id: "baseInformation_buyerReferenceLabel",
        defaultMessage: "Buyer reference"
    },
    baseInformation_buyerReferenceLabel_helpText: {
        id: "baseInformation_buyerReferenceLabel_helpText",
        defaultMessage: "A reference the buyer has requested to be assigned to the invoice, often called \"your reference\". Used by the buyer for internal routing. If buyer has not specifically requested it, the name of the person who ordered or requested the products or services can be used. Must be used when order number is not specified."
    },
    baseInformation_projectReferenceLabel: {
        id: "baseInformation_projectReferenceLabel",
        defaultMessage: "Project reference"
    },
    baseInformation_notes: {
        id: "baseInformation_notes",
        defaultMessage: "Notes"
    },
    baseInformation_currencyCode: {
        id: "baseInformation_currencyCode",
        defaultMessage: "Currency"
    },
    baseInformation_dueDateErrorMsg: {
        id: "baseInformation_dueDateErrorMsg",
        defaultMessage: "Due date must be after the issue date"
    },
    baseInformation_currency_ISK: {
        id: "baseInformation_currency_ISK",
        defaultMessage: "Icelandic krona (ISK)"
    },
    baseInformation_currency_DKK: {
        id: "baseInformation_currency_DKK",
        defaultMessage: "Danish krona (DKK)"
    },
    baseInformation_currency_NOK: {
        id: "baseInformation_currency_NOK",
        defaultMessage: "Norwegian krona (NOK)"
    },
    baseInformation_currency_SEK: {
        id: "baseInformation_currency_SEK",
        defaultMessage: "Swedish krona (SEK)"
    },
    baseInformation_currency_EUR: {
        id: "baseInformation_currency_EUR",
        defaultMessage: "Euro (EUR)"
    },
    baseInformation_currency_USD: {
        id: "baseInformation_currency_USD",
        defaultMessage: "US dollar (USD)"
    },
    baseInformation_currency_GBP: {
        id: "baseInformation_currency_GBP",
        defaultMessage: "British pound (GBP)"
    },
});
var BaseInformation = function (props) {
    var _a = react_1.useState(), dueDateDefaultPickerValue = _a[0], setDueDateDefaultPickerValue = _a[1];
    react_1.useEffect(function () {
        var a = getDueDateLimit(props.form.getFieldValue(["invoice", "issueDate"]), props.dueDateMinimumOffset);
        setDueDateDefaultPickerValue(a);
    }, [props.form.getFieldValue(["invoice", "issueDate"])]);
    var getCurrencies = function (recRequirements) {
        var currencies = [
            {
                key: "ISK",
                name: props.intl.formatMessage(translationMessages.baseInformation_currency_ISK)
            },
            {
                key: "DKK",
                name: props.intl.formatMessage(translationMessages.baseInformation_currency_DKK)
            },
            {
                key: "NOK",
                name: props.intl.formatMessage(translationMessages.baseInformation_currency_NOK)
            },
            {
                key: "SEK",
                name: props.intl.formatMessage(translationMessages.baseInformation_currency_SEK)
            },
            {
                key: "EUR",
                name: props.intl.formatMessage(translationMessages.baseInformation_currency_EUR)
            },
            {
                key: "USD",
                name: props.intl.formatMessage(translationMessages.baseInformation_currency_USD)
            },
            {
                key: "GBP",
                name: props.intl.formatMessage(translationMessages.baseInformation_currency_GBP)
            },
        ];
        var currencyCodeRequirements = RequirementsUtility_1.getFieldRequirements(recRequirements, ReceiverRequirements_1.AvailableFields.currencyCode);
        if (currencyCodeRequirements && currencyCodeRequirements.properties && currencyCodeRequirements.properties.values && currencyCodeRequirements.properties.values.length > 0) {
            return currencyCodeRequirements.properties.values;
        }
        else {
            return currencies;
        }
    };
    var getDueDateLimit = function (issueDate, dueDateMinimumOffset) {
        var dueDateLimit;
        if (issueDate) {
            dueDateLimit = moment_1.default.max(moment_1.default().startOf("day").add(dueDateMinimumOffset, "days"), issueDate.startOf("day"));
        }
        else {
            dueDateLimit = moment_1.default().startOf("day").add(dueDateMinimumOffset, "days");
        }
        return dueDateLimit;
    };
    var disabledDate = function (dueDate, issueDate, dueDateMinimumOffset) {
        var dueDateLimit = getDueDateLimit(issueDate, dueDateMinimumOffset);
        return dueDate < dueDateLimit;
    };
    var checkIfEmpty = function (date) {
        if (!date) {
            props.form.resetFields(["invoice", "dueDate"]);
            props.form.validateFields(["invoice", "dueDate"]).then(function (values) {
                // console.log(values);
            });
        }
    };
    var dueDateLabelNode = (React.createElement(antd_1.Tooltip, { title: props.intl.formatMessage(translationMessages.baseInformation_dueDate_title), placement: "right" },
        React.createElement("span", null,
            props.intl.formatMessage(translationMessages.baseInformation_dueDate),
            "\u00A0",
            React.createElement(icons_1.QuestionCircleOutlined, null))));
    var issueDateLabelNode = (React.createElement(antd_1.Tooltip, { title: props.intl.formatMessage(translationMessages.baseInformation_issueDate_title), placement: "right" },
        React.createElement("span", null,
            props.intl.formatMessage(translationMessages.baseInformation_issueDate),
            "\u00A0",
            React.createElement(icons_1.QuestionCircleOutlined, null))));
    var referenceIdentifierLabelNode = (React.createElement(antd_1.Tooltip, { title: props.intl.formatMessage(ReferenceIdentifiers_1.translationMessages.referenceIdentifiers_labels_referenceIdentifier_title), placement: "right" },
        React.createElement("span", null,
            props.intl.formatMessage(ReferenceIdentifiers_1.translationMessages.referenceIdentifiers_labels_referenceIdentifier),
            "\u00A0",
            React.createElement(icons_1.QuestionCircleOutlined, null))));
    var onlyOneOption = function (receiverRequirements, fieldName) {
        var a = RequirementsUtility_1.getFieldRequirements(receiverRequirements, fieldName);
        return !!(a && a.properties && a.properties.values && a.properties.values.length === 1);
    };
    return (React.createElement(components_1.ComponentContainer, { title: props.intl.formatMessage(translationMessages.baseInformation_title) },
        React.createElement(form_item_1.default, { receiverRequirements: props.receiverRequirements, receiverRequirementsKey: ReceiverRequirements_1.AvailableFields.invoiceNo, defaultLabel: props.intl.formatMessage(translationMessages.baseInformation_invoiceNo), defaultIsRequired: true, fieldName: ["invoice", "invoiceNo"] },
            React.createElement(antd_1.Input, null)),
        React.createElement(form_item_1.default, { receiverRequirements: props.receiverRequirements, receiverRequirementsKey: ReceiverRequirements_1.AvailableFields.issueDate, defaultLabel: issueDateLabelNode, defaultIsRequired: true, fieldName: ["invoice", "issueDate"] },
            React.createElement(antd_1.DatePicker, { style: { width: "100%" }, format: "DD.MM.YYYY" })),
        React.createElement(form_item_1.default
        // dependencies={[["invoice", "issueDate"]]}
        , { 
            // dependencies={[["invoice", "issueDate"]]}
            receiverRequirements: props.receiverRequirements, receiverRequirementsKey: ReceiverRequirements_1.AvailableFields.dueDate, defaultLabel: dueDateLabelNode, defaultIsRequired: true, fieldName: ["invoice", "dueDate"], additionalRules: [
                {
                    validator: (function (rule, value, callback) {
                        if (!value) {
                            callback();
                        }
                        var issueDate = props.form.getFieldValue(["invoice", "issueDate"]);
                        value < issueDate
                            ? callback(props.intl.formatMessage(translationMessages.baseInformation_dueDateErrorMsg))
                            : callback();
                    }),
                },
            ] },
            React.createElement(antd_1.DatePicker, { defaultPickerValue: dueDateDefaultPickerValue, style: { width: "100%" }, format: "DD.MM.YYYY", onChange: checkIfEmpty, getPopupContainer: function (trigger) { return trigger.parentElement; }, disabledDate: (function (current) {
                    var currentDate = current;
                    var dueDateMinimumOffset = props.dueDateMinimumOffset;
                    var issueDate = props.form.getFieldValue(["invoice", "issueDate"]);
                    return disabledDate(currentDate, issueDate, dueDateMinimumOffset);
                }) })),
        React.createElement(OrderReference_1.default, { receiverRequirements: props.receiverRequirements, formInstance: props.form, dependencies: [["invoice", "buyerReference"]] }),
        React.createElement(form_item_1.default, { shouldUpdate: true, dependencies: [["invoice", "orderReference", "documentNo"]], receiverRequirements: props.receiverRequirements, receiverRequirementsKey: ReceiverRequirements_1.AvailableFields.buyerReference, defaultLabel: props.intl.formatMessage(translationMessages.baseInformation_buyerReferenceLabel), defaultLabelTooltip: props.intl.formatMessage(translationMessages.baseInformation_buyerReferenceLabel_helpText), defaultIsRequired: !(props.form.getFieldValue(["invoice", "orderReference", "documentNo"])), fieldName: ["invoice", "buyerReference"] },
            React.createElement(antd_1.Input, null)),
        React.createElement(ReferenceIdentifiers_1.default, { receiverRequirements: props.receiverRequirements, formInstance: props.form, updateReceiverRequirementsProp: props.updateReceiverRequirementsProp, rapiBaseUrl: props.rapiBaseUrl, legalIdentifier: props.legalIdentifier, referenceIdentifiersLabelText: props.referenceIdentifiersLabelText, referenceIdentifiersHelpText: props.referenceIdentifiersHelpText, referenceIdentifierValidateStatus: props.referenceIdentifierValidateStatus, setReferenceIdentifierValidateStatus: props.setReferenceIdentifierValidateStatus }),
        React.createElement(AccountingCost_1.default, { formInstance: props.form, rapiBaseUrl: props.rapiBaseUrl, receiverRequirements: props.receiverRequirements, updateReceiverRequirementsProp: props.updateReceiverRequirementsProp, legalIdentifier: props.legalIdentifier }),
        React.createElement(ProjectReference_1.default, { receiverRequirements: props.receiverRequirements }),
        React.createElement(form_item_1.default, { receiverRequirements: props.receiverRequirements, receiverRequirementsKey: ReceiverRequirements_1.AvailableFields.notes, defaultLabel: props.intl.formatMessage(translationMessages.baseInformation_notes), defaultIsRequired: false, fieldName: ["invoice", "notes"] },
            React.createElement(antd_1.Input.TextArea, null)),
        React.createElement(form_item_1.default, { receiverRequirements: props.receiverRequirements, receiverRequirementsKey: ReceiverRequirements_1.AvailableFields.currencyCode, defaultLabel: props.intl.formatMessage(translationMessages.baseInformation_currencyCode), defaultIsRequired: true, fieldName: ["invoice", "currencyCode"], initialValue: getCurrencies(props.receiverRequirements)[0].key },
            React.createElement(antd_1.Select, { dropdownMatchSelectWidth: false }, getCurrencies(props.receiverRequirements).map(function (currency) {
                return (React.createElement(antd_1.Select.Option, { value: currency.key, title: currency.name, key: currency.key }, currency.name));
            })))));
};
var BaseInformationIntl = react_intl_1.injectIntl(BaseInformation);
exports.default = BaseInformationIntl;
